import { createContext } from 'react';
import { teams } from './crm-filters/crm-user-groups';

const propertyTitles = [
    {
        id: 'Name',
        name: 'Namn',
    },
    {
        id: 'CustomerId',
        name: 'Kund',
    },
    {
        id: 'ContactId',
        name: 'Kontaktperson',
    },
    {
        id: 'HasCommitted',
        name: 'Åtagande',
    },
    {
        id: 'Extent',
        name: 'Omfattning (%)',
    },
    {
        id: 'StartDate',
        name: 'Avtalsstart',
    },
    {
        id: 'EndDate',
        name: 'Avtalsslut',
    },
    {
        id: 'OptionDate',
        name: 'Optionslängd',
    },
    {
        id: 'HourRate',
        name: 'Timpris (till kund)',
    },
    {
        id: 'Consultants',
        name: 'Consid-konsulter',
    },
    {
        id: 'UnderConsultantOrganizations',
        name: 'UK-bolag',
    },
    {
        id: 'UnderConsultants',
        name: 'Underkonsulter',
    },
    {
        id: 'PriceInRate',
        name: 'UK-Pris in (timpris)',
    },
    {
        id: 'MarginRate',
        name: 'UK-Marginal (timpris)',
    },
    {
        id: 'HasAgreement',
        name: 'Lagt upp avtal',
    },
    {
        id: 'InvoiceReference',
        name: 'Fakturareferens',
    },
    {
        id: 'LostReasonId',
        name: 'Förlustorsak',
    },
    {
        id: 'Collaborators',
        name: 'Kollaboratörer',
    },
    {
        id: 'Followers',
        name: 'Följare',
    },
    {
        id: 'OrganizationTypeId',
        name: 'Organisationstyp',
    },
    {
        id: 'Places',
        name: 'Ort',
    },
    {
        id: 'PlaceOther',
        name: 'Ort (Övrigt)',
    },
    {
        id: 'Skills',
        name: 'Tekniskt Miljö',
    },
    {
        id: 'FrameworkAgreement',
        name: 'Ramavtal',
    },
    {
        id: 'PublicSector',
        name: 'Offentlig Sektor',
    },
    {
        id: 'Address',
        name: 'Faktura-adress',
    },
    {
        id: 'OrganizationId',
        name: 'Företag',
    },
    {
        id: 'RoleId',
        name: 'Roll',
    },
    {
        id: 'RoleOther',
        name: 'Lagt upp avtal',
    },
    {
        id: 'Phone',
        name: 'Telefon',
    },
    {
        id: 'Email',
        name: 'Email',
    },
    {
        id: 'OwnerId',
        name: 'Ägare',
    },
    {
        id: 'DealStatus',
        name: 'Deal Status',
    },
    {
        id: 'PipelineStageId',
        name: 'Pipeline Stage',
    },
    {
        id: 'Value',
        name: 'Värde',
    },
    {
        id: 'IsActive',
        name: 'Aktiv',
    },
    {
        id: 'ParentOrganizationId',
        name: 'Huvudbolag',
    },
    {
        id: 'ParentOrganization',
        name: 'Huvudbolag',
    },
    {
        id: 'ChildOrganizations',
        name: 'Dotterbolag',
    },
];

const lostReasons = [
    {
        id: 'CLP',
        name: 'Konkurrent hade lägre pris',
    },
    {
        id: 'OMC',
        name: 'Kund ansåg att vi saknade kompetens',
    },
    {
        id: 'DIV',
        name: 'Dålig intervju',
    },
    {
        id: 'CAA',
        name: 'Consid alt. UK säljer konsult till annat uppdrag',
    },
];

const mockLabels = [
    {
        id: 'CSA',
        name: 'Customer (A)',
        description: 'Möjlig kundvolym >40 FTE på årsbasis.',
        color: '#145A32',
    },
    {
        id: 'CSB',
        name: 'Customer (B)',
        description: 'Möjlig kundvolym 5-40 FTE på årsbasis.',
        color: '#07a742',
    },
    {
        id: 'CSC',
        name: 'Customer (C)',
        description: 'Möjlig kundvolym <5 FTE på årsbasis.',
        color: '#1f618d',
    },
    {
        id: 'CSD',
        name: 'Customer (D)',
        description: 'Låg möjlig kundvolym.',
        color: '#2e86c1',
    },
    {
        id: 'LEA',
        name: 'Lead (A- & B-prospekt)',
        description: 'Potential till >5 FTE på årsbasis.',
        color: '#f94839',
    },
    {
        id: 'LEC',
        name: 'Lead (C-prospekt)',
        description: 'Potential till <5 FTE på årsbasis.',
        color: '#f39C12',
    },
    {
        id: 'LED',
        name: 'Lead (D-prospekt)',
        description: 'Mindre potential.',
        color: '#ffcc00',
    },
    {
        id: 'CLD',
        name: 'Cold Lead',
        description: 'Okänd potential.',
        color: '#e5e5e5',
    },
    {
        id: 'UKB',
        name: 'UK-Bolag',
        description: 'Underkonsultbolag.',
        color: '#5d6d7',
    },
];

const dealStatusOptions = [
    {
        id: 'null',
        name: 'OPEN',
    },
    {
        id: 'true',
        name: 'WON',
    },
    {
        id: 'false',
        name: 'LOST',
    },
];

const dealUserOptions = [
    {
        id: 'collab',
        name: 'Mina kollaborationer',
    },
];

const activityTypeIcons = {
    BOM: 'calendar-check',
    COM: 'people',
    YIA: 'graph',
};

const userFilterTypes = [
    {
        id: 'user',
        name: 'Användare',
        icon: 'user',
    },
    {
        id: 'boss',
        name: 'Användare under chef',
        icon: 'diagram',
    },
    {
        id: 'group',
        name: 'Kontor',
        icon: 'office',
    },
    {
        id: 'team',
        name: 'Användargrupp',
        icon: 'people',
    },
];

const getMatchingLabel = (name) => {
    const matching = mockLabels.find((ml) => ml.name.toLowerCase() === name.toLowerCase());
    return matching;
};

const getLabelColor = (name) => {
    const matching = getMatchingLabel(name);
    return matching.color;
};
const getLabelDescription = (name) => {
    const matching = getMatchingLabel(name);
    return matching.description;
};

const correctColors = (labels) => {
    labels.forEach((l) => {
        if (!!getMatchingLabel(l.name)) {
            l.color = getLabelColor(l.name);
            l.description = getLabelDescription(l.name);
        }
    });
    return labels;
};

const setActivityTypeIcons = (types) => {
    types.forEach((t) => {
        t.icon = activityTypeIcons[t.id];
    });
    return types;
};

export const initialState = {
    areSelectOptionsFetched: false,
    isFetchingSelectOptions: false,
    pipelineOptions: null,
    placeOptions: null,
    officeOptions: null,
    teamsOptions: teams,
    dealStatusOptions: dealStatusOptions,
    dealUserOptions: dealUserOptions,
    LabelOptions: null,
    RoleOptions: null,
    SkillOptions: null,
    ActivityTypeOptions: null,
    lostReasonOptions: lostReasons,
    isSavedToastOpen: false,
    isDeletedToastOpen: false,
    isErrorToastOpen: false,
    isGenericExlErrorToastOpen: false,
    genericExlErrorToastMsg: null,
    anchorTag: null,
    startDate: null,
    endDate: null,
    bossGroups: [
        {
            id: 'null',
            name: 'Laddar...',
            users: [],
        },
    ],
    userGroups: [],
    userFilterTypes: userFilterTypes,
    searchCategories: [
        {
            name: 'Alla kategorier',
            index: null,
            icon: 'grid',
        },
        {
            name: 'Deals',
            index: 0,
            icon: 'deal',
        },
        {
            name: 'Personer',
            index: 1,
            icon: 'people',
        },
        {
            name: 'Organisationer',
            index: 2,
            icon: 'organization',
        },
        {
            name: 'Aktiviteter',
            index: 3,
            icon: 'calendar',
        },
        {
            name: 'Filer',
            index: 4,
            icon: 'file',
        },
        {
            name: 'Sök i filer',
            index: 5,
            icon: 'file-text',
        },
    ],
    propertyTitles: propertyTitles,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_PIPELINE_OPTIONS':
            return {
                ...state,
                pipelineOptions: action.payload,
            };
        case 'UPDATE_LABEL_OPTIONS':
            return {
                ...state,
                LabelOptions: correctColors(action.payload),
            };
        case 'UPDATE_ROLE_OPTIONS':
            return {
                ...state,
                RoleOptions: action.payload,
            };
        case 'UPDATE_SKILL_OPTIONS':
            return {
                ...state,
                SkillOptions: action.payload,
            };
        case 'UPDATE_ACTIVITY_TYPE_OPTIONS':
            return {
                ...state,
                ActivityTypeOptions: setActivityTypeIcons(action.payload),
            };
        case 'UPDATE_PLACE_OPTIONS':
            return {
                ...state,
                placeOptions: action.payload,
            };
        case 'UPDATE_OFFICE_OPTIONS':
            return {
                ...state,
                officeOptions: action.payload,
            };
        case 'UPDATE_BOSS_GROUP_OPTIONS':
            return {
                ...state,
                bossGroups: action.payload,
            };
        case 'SET_OPTIONS_FETCHED':
            return {
                ...state,
                isFetchingSelectOptions: true,
            };
        case 'FINISHED_OPTIONS_FETCH':
            return {
                ...state,
                isFetchingSelectOptions: false,
                areSelectOptionsFetched: true,
            };
        case 'SHOW_SAVED_TOAST':
            return {
                ...state,
                isSavedToastOpen: true,
            };
        case 'SHOW_DELETED_TOAST':
            return {
                ...state,
                isDeletedToastOpen: true,
            };
        case 'SHOW_ERROR_TOAST':
            return {
                ...state,
                isErrorToastOpen: true,
            };
        case 'SHOW_GENERIC_EXL_ERROR_TOAST':
            return {
                ...state,
                genericExlErrorToastMsg: action.payload,
                isGenericExlErrorToastOpen: true,
            };
        case 'CLOSE_SAVED_TOAST':
            return {
                ...state,
                isSavedToastOpen: false,
            };
        case 'CLOSE_DELETED_TOAST':
            return {
                ...state,
                isDeletedToastOpen: false,
            };
        case 'CLOSE_ERROR_TOAST':
            return {
                ...state,
                isErrorToastOpen: false,
            };
        case 'CLOSE_GENERIC_EXL_ERROR_TOAST':
            return {
                ...state,
                genericExlErrorToastMsg: null,
                isGenericExlErrorToastOpen: false,
            };
        case 'SET_ANCHOR_TAG':
            return {
                ...state,
                anchorTag: action.payload,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
